import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import { select } from '../../styles/components/forms.style';

export const img = css`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  margin: 30px auto 0;
  border: 2px solid ${appColors.gray100};

  @media (min-width: ${breakpoints.lg.up}) {
    width: 215px;
    height: 215px;
  }

  & > img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    display: block;
    margin: auto;

    @media (min-width: ${breakpoints.lg.up}) {
      width: 150px;
      height: 150px;
    }
  }
`;

const colors = [
  '#1ec0ff',
  '#87daa2',
  '#ffc853',
  '#f05c5c',
  '#9187da',
  '#da8787',
  '#87b4da',
  '#c287da',
  '#9187da',
  '#87daae',
  '#dd62ef',
];

export const title = css`
  font-size: 36px;
  font-family: ${fontFamily.fredoka};
  text-align: center;
  margin: 0;

  ${colors.map(
    (color, index) => `
    & > span:nth-child(${index + 1}) {
      color: ${color};
    }
  `
  )}

  @media (min-width: ${breakpoints.md.up}) {
    font-size: 56px;
  }
`;

export const line = css`
  font-size: 24px;
  margin: 0 0 40px;
  text-align: center;
  font-style: italic;

  span {
    color: ${appColors.orange};
  }
`;

export const summary = css`
  width: 270px;
  border-radius: 10px;
  padding: 30px 20px 10px;
  margin: 0 auto 30px;
  border: 2px solid ${appColors.orange};
  text-align: center;

  .s-title {
    font-size: 55px;
    color: ${appColors.orange};
    font-family: ${fontFamily.fredoka};
    margin: 0;
  }

  .sub-title {
    font-family: ${fontFamily.fredoka};
    font-size: 20px;
    margin: 0;
  }

  .line {
    font-size: 14px;
    margin: 0 0 35px;

    &.no-margin {
      margin: 0;
    }
  }

  .row {
    display: flex;
    margin: 0 -6px;
  }

  .item {
    flex: 0 0 50%;
    padding: 0 6px;

    &:not(:last-child) {
      border-right: 1px solid ${appColors.gray200};
    }

    &-title {
      font-family: ${fontFamily.fredoka};
      font-size: 30px;
      color: var(--color);
      margin: 0;
    }
  }
`;

export const label = css`
  display: block;
  font-size: 24px;
  margin: 0 0 10px;
  text-align: center;
`;

export const select2 = css`
  ${select}
  max-width: 480px;
  margin: 0 auto;
`;

export const list = css`
  max-width: 710px;
  margin: -10px auto 0;
  position: relative;
  z-index: 1;

  @media (min-width: ${breakpoints.lg.up}) {
    margin: -350px auto 0;
  }
`;

export const listItem = css`
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  width: 100%;
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid ${appColors.gray500};
  padding: 20px 15px;
  border-radius: 8px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  text-align: left;
  color: ${appColors.gray800};

  @media (min-width: ${breakpoints.lg.up}) {
    flex-direction: row;
    height: 88px;
    padding: 0 38px;
  }

  &:hover {
    background: ${appColors.gray100};
    color: ${appColors.gray800};
  }

  & > .count {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid ${appColors.gray500};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${appColors.gray500};
    margin-bottom: 20px;

    @media (min-width: ${breakpoints.lg.up}) {
      margin-right: 47px;
      margin-bottom: 0;
    }
  }

  & > .avatar {
    ${img}

    margin: 0;
    border-color: ${appColors.gray500};
    width: 70px;
    height: 70px;

    @media (min-width: ${breakpoints.md.up}) {
      margin-right: 22px;
      width: 70px;
      height: 70px;
    }
  }

  & > .username {
    flex: 1;
    font-family: ${fontFamily.fredoka};
    font-size: 18px;
    margin: 10px 0;

    @media (min-width: ${breakpoints.lg.up}) {
      margin: 0;
    }
  }

  & > .points {
    font-family: ${fontFamily.fredoka};
    font-size: 18px;
    color: ${appColors.yellow};
    display: flex;
    align-items: center;
    margin: 0;

    @media (min-width: ${breakpoints.lg.up}) {
      border-left: 1px solid ${appColors.yellow};
      padding-left: 30px;
    }

    & > img {
      margin-right: 25px;
    }
  }
`;

export const glitter = css`
  max-width: 100%;
  display: block;
`;
